const IndexMobile = () => import('views/vodm/IndexMobile')
const HomeMobile = () => import('views/vodm/HomeMobile')
const VideoPageMobile = () => import('views/vodm/VideoPageMobile')
const SearchPageMobile = () => import('views/vodm/SearchPageMobile')
const MyPageMobile = () => import('views/vodm/MyPageMobile')
const MyHistoryMobile = () => import('views/vodm/MyHistoryMobile')
const MyFavMobile = () => import('views/vodm/MyFavMobile')
const MyFavItemMobile = () => import('views/vodm/MyFavItemMobile')
const AlbumPlaylistMobile = () => import('views/vodm/AlbumPlaylistMobile')
const WatchLaterMobile = () => import('views/vodm/WatchLaterMobile')
const MyWalletMobile = () => import('views/vodm/MyWalletMobile')

const ShareVideo = () => import('views/vod/ShareVideo')
const TimelineIndex = () => import('views/vodm/Timeline')
const RegionIndex = () => import('views/vod/Region')
const VideoTag = () => import('views/vod/VideoTag')
const AlbumIndex = () => import('views/vodm/AlbumIndex')
const AlbumImage = () => import('views/vodm/AlbumImage')

export default {
  path: '/',
  name: 'Vod',
  component: IndexMobile,
  meta: { needAuth: false },
  children: [
    {
      path: '',
      name: 'Home',
      component: HomeMobile,
      meta: { needAuth: false }
    },
    {
      path: '/my',
      name: 'MyPageMobile',
      component: MyPageMobile,
      meta: { needAuth: true }
    },
    {
      path: '/my/watch_later',
      name: 'WatchLaterMobile',
      component: WatchLaterMobile,
      meta: { needAuth: false }
    },
    {
      path: '/my/history',
      name: 'MyHistoryMobile',
      component: MyHistoryMobile,
      meta: { needAuth: true }
    },
    {
      path: '/my/fav',
      name: 'MyFavMobile',
      component: MyFavMobile,
      meta: { needAuth: true }
    },
    {
      path: '/my/fav_item/:id',
      name: 'MyFavItemMobile',
      component: MyFavItemMobile,
      meta: { needAuth: true }
    },
    {
      path: '/my/wallet',
      name: 'MyWalletMobile',
      component: MyWalletMobile,
      meta: { needAuth: true }
    },
    {
      path: '/timeline',
      name: 'TimelineIndex',
      component: TimelineIndex,
      meta: { needAuth: true }
    },
    {
      path: '/region',
      name: 'RegionIndex',
      component: RegionIndex,
      meta: { needAuth: false }
    },
    {
      path: '/search',
      name: 'SearchPageMobile',
      component: SearchPageMobile,
      meta: { needAuth: false },
      children: [
      ]
    },
    {
      path: '/video/:id',
      name: 'VideoPage',
      component: VideoPageMobile,
      meta: { needAuth: false }
    },
    {
      path: '/video/tag/:tag',
      name: 'VideoTag',
      component: VideoTag,
      meta: { needAuth: false }
    },
    {
      path: '/image/:albumId',
      name: 'AlbumImage',
      component: AlbumImage,
      meta: { needAuth: false }
    },
    {
      path: '/playlist',
      name: 'AlbumIndex',
      component: AlbumIndex,
      meta: { needAuth: false }
    },
    {
      path: '/playlist/play/:albumId',
      name: 'AlbumPlaylist',
      component: AlbumPlaylistMobile,
      meta: { needAuth: false }
    },
    {
      path: '/s/:shareId',
      name: 'ShareVideo',
      component: ShareVideo,
      meta: { needAuth: false }
    }
  ]
}
